import { EnvironmentModel } from './environment.model';

export const environment: EnvironmentModel = {
  production: false,
  urlServiceJava: 'https://apihomol.ebarn.com.br',
  // urlServerNode: 'http://localhost:3030',
  urlServerNode: 'https://apinodehomol.ebarn.com.br',
  appUrl: 'https://teste.cxm.ebarn.com.br',
  homeApp: 'https://teste.ebarn.com.br',
  nome: 'ebarn',
  whatsappSuporte: '556296917063',
  indexHtml: {
    facebookDomainVerification: 'trjirhr7hmuoogvlxvy96fwhdmqyn9',
    pixelFacebook: '460136894561691',
    googleAnalytics: 'UA-124223519-2'
  },
  googlePlay: 'https://play.google.com/store/apps/details?id=br.com.ebarn.app',
  appleStore: 'https://apps.apple.com/br/app/ebarn/id1515576910?l=pt-br',
  redesSociais: {
    youtube: 'https://www.youtube.com/channel/UCptk7lNNsSeIwo1Rsh4VUUA',
    facebook: 'https://www.facebook.com/ebarn.agro',
    instagram: 'https://www.instagram.com/ebarn.agro',
    linkedin: 'https://www.linkedin.com/company/ebarn'
  },
  repoS3: 'https://repo-files-customers.s3.sa-east-1.amazonaws.com/ebarn'
};
